/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const Home = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.5 10.1667L12 3.5L4.5 10.1667V19.9932H9V16.4931C9 14.8362 10.3431 13.4931 12 13.4931C13.6569 13.4931 15 14.8362 15 16.4931V19.9932H21V21.4932H14V21.4931H13.5V16.4931C13.5 15.6646 12.8284 14.9931 12 14.9931C11.1716 14.9931 10.5 15.6646 10.5 16.4931V21.4931H10V21.4932H4V21.4931H3V10.1667C3 9.73821 3.18322 9.3302 3.50345 9.04555L11.0035 2.37889C11.5718 1.8737 12.4282 1.8737 12.9965 2.37889L20.4965 9.04555C20.8168 9.3302 21 9.73821 21 10.1667V18.4931H19.5V10.1667Z"
                        fill={color}
                    />
                </svg>
        );
    };
